var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-date-picker',{attrs:{"config":_vm.config,"value":_vm.selected,"placeholder":"Séléctionnez une période"},on:{"on-change":_vm.handleChange,"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }